import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

const DEFAULT_USERS = [
  { id:1, name:'Dhanush Sathyanarayanan', username:'dhanush', email:'dhanush@ryzenforge.in', password:'Ryzen@2113', role:'Super Admin', dept:'Management', initials:'DS' },
];

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(sessionStorage.getItem('ryzenos_session')) || null; } catch { return null; }
  });

  const getUsers = () => {
    try {
      const team = JSON.parse(localStorage.getItem('ryzenos_team') || '[]');
      const teamUsers = team.filter(m => m.username && m.password).map(m => ({
        id: m.id, name: m.name, username: m.username, email: m.email || '',
        password: m.password, role: m.userRole || 'User', dept: m.dept || '',
        initials: m.avatar || m.name.split(' ').map(w=>w[0]).join('').slice(0,2).toUpperCase(),
      }));
      // Merge default users with team users (team users override by username)
      const teamUsernames = new Set(teamUsers.map(u=>u.username));
      const defaults = DEFAULT_USERS.filter(u=>!teamUsernames.has(u.username));
      return [...defaults, ...teamUsers];
    } catch { return DEFAULT_USERS; }
  };

  const login = (usernameOrEmail, password) => {
    const users = getUsers();
    const found = users.find(u =>
      (u.username === usernameOrEmail || u.email === usernameOrEmail) && u.password === password
    );
    if (found) {
      const session = { id:found.id, name:found.name, email:found.email, role:found.role, dept:found.dept, initials:found.initials, username:found.username };
      sessionStorage.setItem('ryzenos_session', JSON.stringify(session));
      setUser(session);
      return { success:true };
    }
    return { success:false, error:'Invalid username or password' };
  };

  const logout = () => {
    sessionStorage.removeItem('ryzenos_session');
    setUser(null);
  };

  const isAuthenticated = !!user;

  return (
    <AuthContext.Provider value={{ user, login, logout, isAuthenticated, getUsers }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
